import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * cn — class name utility. Combines clsx (conditional classes) with tailwind-merge
 * (resolves conflicts intelligently, e.g. "px-2 px-4" → "px-4").
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format number with Polish locale (12 345).
 */
export function formatNumber(n) {
  if (n == null || isNaN(n)) return '—';
  return Number(n).toLocaleString('pl-PL');
}

/**
 * Format date as "5 maj 2026, 14:32".
 */
export function formatDateTime(d) {
  if (!d) return '—';
  const date = new Date(d);
  return date.toLocaleString('pl-PL', {
    day: 'numeric', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

/**
 * Initials from email or full name.
 */
export function getInitials(str) {
  if (!str) return '?';
  const local = str.split('@')[0];
  const parts = local.split(/[._-\s]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return local.slice(0, 2).toUpperCase();
}
